import { BaseballLineupPosition } from '@trackman/baseball-shared-components';
import { ReactComponent as MinusIcon } from 'components/icons/delete.svg';
import { ReactComponent as PlusIcon } from 'components/icons/plus-circle.svg';
import { ILineupEntry } from 'interfaces/team/ILineupEntry';
import { IPlayer } from 'interfaces/team/IPlayer';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { ForeignIdSelector } from './ForeignIdSelector';
import { EntryNumber, ForeignId, PullRight, RosterPlayerName, RosterPlayerWrapper } from './RosterPlayerStyles';

interface IProps {
  player: IPlayer;
  addPlayerToLineup: (player: IPlayer, position?: BaseballLineupPosition) => void;
  removePlayerFromLineup: (player: IPlayer) => void;
  isInLineup: boolean;
  isUnavailable: boolean;
  size: 'sm' | 'lg';
  index: number;
  lineup: ILineupEntry[];
}
export const RosterPlayer: React.FC<IProps> = observer((props) => {
  const { player, addPlayerToLineup, removePlayerFromLineup, isInLineup, isUnavailable, size, index, lineup } = props;

  const isValidPosition = (position?: string): position is BaseballLineupPosition => {
    return Object.values(BaseballLineupPosition).includes(position as BaseballLineupPosition);
  };

  const addPlayerHandler = () => {
    if (player.positions.length > 0 && player.positions[0] === BaseballLineupPosition.Pitcher) {
      const pitcher = lineup.find((p) => p.position === BaseballLineupPosition.Pitcher);

      if (pitcher?.player) {
        return addPlayerToLineup(player, undefined);
      }
    }

    if (player.positions.length > 0) {
      return addPlayerToLineup(player, isValidPosition(player.positions[0]) ? player.positions[0] : undefined);
    }

    return addPlayerToLineup(player, undefined);
  };

  return (
    <RosterPlayerWrapper className={`roster-player${isInLineup || isUnavailable ? ' in-lineup' : ''}`}>
      <EntryNumber>{index + 1}</EntryNumber>
      <RosterPlayerName className='roster-player-name'>
        {player.lastName}, {player.firstName} {player.jerseyNumber ? `#${player.jerseyNumber}` : ''}
      </RosterPlayerName>
      <PullRight className='pull-right' size={size}>
        <ForeignId className='foreign-id'>{ForeignIdSelector.get(player.foreignIds)}</ForeignId>
        {isInLineup || isUnavailable ? (
          !isUnavailable && (
            <MinusIcon onClick={() => removePlayerFromLineup(player)} className='minus-icon' data-test='remove-player-icon' />
          )
        ) : (
          <PlusIcon onClick={addPlayerHandler} className='plus-icon' data-test='add-player-icon' />
        )}
      </PullRight>
    </RosterPlayerWrapper>
  );
});
